<template>
  <div class="card">
    <header class="bandeau-modal card-header">
    </header>
    <div class="card-content">
      <h1 class="title has-text-centered mgb-20px">
        {{ $t('listeDemandeImpression.popUpModificationGraphiste.title') }}
      </h1>
      <error-msg-component
        :error="isErrorPopup"
        :champsVide="champsVide"
        :messages="messagesPopup"
        :messagesChampsVide="messagesChampsVide"
        title="general.problemOccurred"
        @close="isErrorPopup = $event"
        withEmplyFields/>
      <section class="mgt-10px">
        <div class="columns">
          <div class="column is-12">
            <user-autocomplete
               v-model="graphisteEnChargeId"
               :label="$t('editionDemandeImpression.infoGenerale.graphisteEnCharge')"
               :obligatoire="true"
            />
          </div>
        </div>
      </section>
      <footer class="mgt-20px">
        <div class="has-text-centered">
          <button
            class="button btn-modal-annuler is-cancel has-text-centered button-modal"
            @click="$emit('close')">
            {{ $t('general.button.cancel') }}
          </button>
          <button class="button is-addOrEdit has-text-centered button-modal"
                  @click="updateMasseGraphiste">
            {{ $t('general.button.valider') }}
          </button>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import { updateGraphisteDemandeImpressionAll } from '@/api/logistique/demandeImpression';
import userAutocomplete from '@/components/commun/user/userAutocomplete';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import messageSucces from '@/services/general/messageSucces';
import messageErreur from '@/services/general/messageErreur';
import validationGeneral from '@/services/validation/validation';
import translate from '@/services/logistique/demandeImpression/translateDemandeImpression';

export default {
  components: {
    errorMsgComponent,
    userAutocomplete,
  },
  props: {
    demandeImpressions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      graphisteEnChargeId: null,
      messagesPopup: [],
      messagesChampsVide: [],
      champsVide: [],
      isErrorPopup: false,
    };
  },
  methods: {
    async updateMasseGraphiste() {
      this.messagesChampsVide = [];
      this.champsVide = [];
      this.messagesPopup = [];
      this.isErrorPopup = false;
      const loadingComponent = this.$buefy.loading.open();
      try {
        const demandeImpressionIds = this.demandeImpressions.map(demande => demande.id);
        await updateGraphisteDemandeImpressionAll({
          ids: demandeImpressionIds,
          graphisteEnChargeId: this.graphisteEnChargeId,
        });
        messageSucces(this.$i18n.t('detailOrdreTravailTech.messages.changer.success'));
        this.$emit('update');
      } catch (e) {
        if (e.response?.data?.error) {
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messagesPopup, this.messagesChampsVide, translate);
          this.isErrorPopup = true;
          return;
        }
        messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
  },
};
</script>
